export default __webpack_public_path__ + "static/media/design_web.062770e4.png";